import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

export const TransitionContainerNoAnimation = styled.div`
    background-color: white;
    display: flex;
    flex-direction: row;
    flex: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
`;

const TransitionContainer = styled(TransitionContainerNoAnimation)`
    max-width: 100%;
    z-index: 2;

    &.transition-enter {
        transform: ${props =>
            props.isBackTransition ? 'translate3d(0, 0, 0)' : 'translate3d(100%, 0, 0)'};
        z-index: ${props => props.zIndex || 10};
        background-color: white;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    &.transition-enter.transition-enter-active {
        transition: transform 0.45s;
        transition-timing-function: ease-out;
        transform: translate3d(0, 0, 0);
    }

    ${props =>
        props.isBackTransition
            ? `&.transition-exit {
                    transition: transform 0.45s;
                    transition-timing-function: ease-in;
                    z-index: 40;
                }`
            : ''};

    ${props =>
        !props.isSubmitting
            ? `&.transition-exit {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: ${props => props.zIndex || 10};
                    background-color: white;
                }

                &.transition-exit.transition-exit-active {
                    transition: transform 0.45s;
                    transition-timing-function: ease-in;
                    transform: translate3d(100%, 0, 0);
                }`
            : ''};
`;

export const TransitionContainerNoExitStyledComponent = styled(
    TransitionContainerNoAnimation
)`
    z-index: 2;
    &.transition-enter {
        transform: ${props =>
            props.isNextActionTransition
                ? 'translate3d(0, 100%, 0);'
                : 'translate3d(100%, 0, 0);'};
        z-index: ${props => props.zIndex || 22};
    }

    &.transition-enter.transition-enter-active {
        transition: transform 0.45s;
        transition-timing-function: ease-out;
        transform: translate3d(0, 0, 0);
    }

    &.transition-exit {
        opacity: 1;
        z-index: ${props => props.zIndex - 5 || 17};
    }

    &.transition-exit.transition-exit-active {
        opacity: 0;
        transition: opacity 0.45s step-end;
    }

    &.backtransition-enter {
        opacity: 0;
        z-index: ${props => props.zIndex || 22};
    }

    &.backtransition-enter.backtransition-enter-active {
        transition: opacity 0.45s ease-out;
        opacity: 1;
    }

    &.backtransition-exit {
        opacity: 1;
        z-index: ${props => props.zIndex - 5 || 17};
        transform: translate3d(0, 0, 0);
    }

    &.backtransition-exit.backtransition-exit-active {
        transition: transform 0.45s;
        transition-timing-function: ease-in;
        transform: translate3d(100%, 0, 0);
    }
`;

export const TransitionContainerNoExit = props =>
    !props.noAnimation ? (
        <TransitionContainerNoExitStyledComponent {...props}>
            {props.children}
        </TransitionContainerNoExitStyledComponent>
    ) : (
        <TransitionContainerNoAnimation>{props.children}</TransitionContainerNoAnimation>
    );

TransitionContainerNoExit.propTypes = {
    noAnimation: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default TransitionContainer;
